import { Minus, Plus } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const Step = ({ label, hint, value, onDec, onInc, decDisabled, incDisabled, id }) => (
  <div className="flex items-center justify-between py-4">
    <div>
      <p className="font-semibold text-ink">{label}</p>
      <p className="text-sm text-muted2">{hint}</p>
    </div>
    <div className="flex items-center gap-4">
      <button data-testid={`${id}-decrement`} disabled={decDisabled} onClick={onDec} className="flex h-8 w-8 items-center justify-center rounded-full border border-ink/30 disabled:opacity-25"><Minus className="h-3.5 w-3.5" /></button>
      <span data-testid={`${id}-count`} className="w-4 text-center">{value}</span>
      <button data-testid={`${id}-increment`} disabled={incDisabled} onClick={onInc} className="flex h-8 w-8 items-center justify-center rounded-full border border-ink/30 disabled:opacity-25"><Plus className="h-3.5 w-3.5" /></button>
    </div>
  </div>
);

export const GuestPicker = ({ b }) => {
  const { t } = useI18n();
  const full = b.adults + b.children >= b.maxGuests;
  return (
    <div className="divide-y divide-ink/10">
      <Step id="adults" label={t("w.adults")} hint={t("w.adultsHint")} value={b.adults} decDisabled={b.adults <= 1} incDisabled={full} onDec={() => b.setAdults(b.adults - 1)} onInc={() => b.setAdults(b.adults + 1)} />
      <Step id="children" label={t("w.children")} hint={t("w.childrenHint")} value={b.children} decDisabled={b.children <= 0} incDisabled={full} onDec={() => b.setChildren(b.children - 1)} onInc={() => b.setChildren(b.children + 1)} />
      <p className="pt-4 text-xs text-muted2">{t("w.max", { n: b.maxGuests })}</p>
    </div>
  );
};
